export const routeTitleMap = {
    "/app/dashboard": "Dashboard",
    "/app/applications": "Applications",
    "/app/users": "Users",
    "/app/plans": "Subscription Plans",
    "/app/settings": "Settings",
};

export const getTitleFromPath = (pathname) => {
    if (pathname.startsWith("/app/applications/")) return "Application Detail";
    return routeTitleMap[pathname] || "";
}; 